import { CONTROLLER_NAMES } from "../../common/constants"
export const Menu = [
    {
        id: [CONTROLLER_NAMES.MedicinePacking],
        icon: "tabler:pill",
        path: "/requests",
        name: "requests"
    },
    {
        id: [CONTROLLER_NAMES.DoctorApprovalRequests],
        icon: "tabler:clipboard-list",
        path: "/order-review",
        name: "order-review"
    },
    {
        id: [CONTROLLER_NAMES.ChangeMedicinesRequestsDoctor],
        icon: "lucide:git-pull-request",
        path: "/change-requests",
        name: "change-requests"
    },
    {
        id: [CONTROLLER_NAMES.MobManualRequests],
        icon: "hugeicons:give-pill",
        path: "/manual-receive",
        name: "manual-receive"
    },
    {
        id: [CONTROLLER_NAMES.MobPatientMedicalServices, CONTROLLER_NAMES.MobDiagnosRequests, CONTROLLER_NAMES.PatientMedicines],
        icon: "lsicon:place-order-filled",
        path: "/doctor-orders",
        name: "doctor-orders"
    },

    {
        id: [CONTROLLER_NAMES.Receivingreturns],
        icon: "hugeicons:return-request",
        path: "/req-return",
        name: "req-return"
    },
    {
        id: [CONTROLLER_NAMES.MobRecurringRequests],
        icon: "material-symbols:orders-outline-rounded",
        path: "/recurring-requests",
        name: "recurring-requests-page"
    },
    {
        id: [CONTROLLER_NAMES.WaitingForPacking],
        icon: "streamline-ultimate:warehouse-cart-package-ribbon",
        path: "/waiting-for-packing",
        name: "waitingForPacking"
    },

]

